import BaseComponent from 'foundation/base-component';
import React from 'react';
import ReactDOM from 'react-dom';
import MakeStoriesLayout from './make-stories-layout.js';

class MakeStoriesComponent extends BaseComponent {
    constructor(...args) {
        super(...args);

        ReactDOM.render(
            <MakeStoriesLayout options={this.options} />,
            this.element
        );
    }
}

export default MakeStoriesComponent;
